import React from 'react';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'light' | 'dark' | 'navy' | 'steel' | 'contrast' | 'warm' | 'slate-gradient' | 'accent';
}

export const Section: React.FC<SectionProps> = ({ 
  children, 
  className = '',
  id,
  background = 'white' 
}) => {
  const backgrounds: Record<string, string> = {
    white: "bg-white",
    light: "bg-slate-50/80",
    dark: "bg-slate-900 text-white",
    navy: "bg-slate-950 text-white",
    steel: "bg-gradient-to-b from-slate-100 to-slate-50 border-y border-slate-200/60",
    contrast: "bg-gradient-to-b from-slate-50 to-white",
    warm: "bg-gradient-to-br from-orange-50/40 via-white to-slate-50/60",
    'slate-gradient': "bg-gradient-to-b from-slate-800 via-slate-900 to-slate-950 text-white",
    accent: "bg-gradient-to-br from-orange-50/30 via-white to-slate-50/40 border-y border-orange-100/50",
  };

  return (
    <section 
      id={id} 
      className={`py-20 md:py-28 ${backgrounds[background]} ${className}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {children}
      </div>
    </section>
  );
};
